import React, { useCallback, useEffect, useState } from 'react';
import isEmail from 'validator/lib/isEmail';

import PropTypes from 'prop-types';

import { prices, phoneNumber } from '../utils/contentProvider';

// eslint-disable-next-line no-unused-vars
const JoinForm = ({ step, formSubmitted, setFormSubmitted, isMobile }) => {
  const [input, setInput] = useState({
    fullName: '',
    email: '',
    phoneCountry: '🇺🇸 +1',
    phoneNumber: '',
    company: '',
    jobTitle: '',
    jobPostings: '0',
  });
  const [isSubmitting, setSubmitting] = useState(false);
  const [error, setError] = useState({});

  const inputChangeHandler = useCallback((e) => {
    const { value, name } = e.target;

    setInput((state) => ({ ...state, [name]: value }));
  }, []);

  const submitHandler = useCallback(
    (e) => {
      e.preventDefault();

      setSubmitting(true);

      if (validateFields()) {
        const head = document.querySelector('head');
        const newScript = document.createElement('script');

        newScript.type = 'text/javascript';
        newScript.src = `https://pwilleterno.activehosted.com/proc.php?u=1&f=1&s&c=0&m=0&act=sub&v=2&fullname=${encodeURIComponent(
          input.fullName,
        )}&email=${encodeURIComponent(input.email)}&phone=${encodeURIComponent(
          `+${phoneNumber.find((i) => i.label === input.phoneCountry).value}${
            input.phoneNumber
          }`,
        )}&field[2]=${encodeURIComponent(
          input.company,
        )}&field[3]=${encodeURIComponent(
          input.jobTitle,
        )}&field[5]=${encodeURIComponent(input.jobPostings)}&jsonp=true`;

        newScript.onload = () => {
          setSubmitting(false);
          setFormSubmitted(true);
          newScript.remove();
        };

        head.appendChild(newScript);
      } else {
        setSubmitting(false);
      }
    },
    [input],
  );

  const validateFields = useCallback(() => {
    const newErrors = {};

    setError({});

    if (input.fullName.trim().length === 0)
      newErrors.fullName = 'Please enter name.';

    if (input.email.trim().length === 0)
      newErrors.email = 'Please enter email.';

    if (input.email.trim().length > 0 && isEmail(input.email) === false)
      newErrors.email = 'Please enter a valid email address.';

    if (input.phoneNumber.trim().length === 0)
      newErrors.phoneNumber = 'Please enter phone number.';

    if (input.company.trim().length === 0)
      newErrors.company = 'Please enter company name.';

    if (input.jobTitle.trim().length === 0)
      newErrors.jobTitle = 'Please enter job title.';

    setError(newErrors);

    return Object.keys(newErrors).length === 0;
  }, [input]);

  useEffect(() => {
    setInput((state) => ({ ...state, jobPostings: prices.jobs[step] }));
  }, [step]);

  return (
    <form
      className={`${formSubmitted ? 'hide' : ''}`}
      onSubmit={submitHandler}
      noValidate>
      <div className="flex-row nowrap no-margin align-items-center">
        <h4>Join the Waitlist</h4>
        <h5 className="yellow-heading">Save 20&#37;, pre launch offer</h5>
      </div>
      <div className="form-group">
        <label htmlFor="form-fullname">
          Name
          <input
            type="text"
            id="form-fullname"
            placeholder="Enter your name"
            name="fullName"
            onChange={inputChangeHandler}
            value={input.fullName}
            required
          />
        </label>
        {error.fullName && <p className="red">{error.fullName}</p>}
      </div>
      <div className="form-group">
        <label htmlFor="form-email">
          Email address
          <input
            type="email"
            id="form-email"
            placeholder="Enter your work email address"
            name="email"
            onChange={inputChangeHandler}
            value={input.email}
            required
          />
        </label>
        {error.email && <p className="red">{error.email}</p>}
      </div>
      <div className="form-group">
        <label htmlFor="form-phone">
          Phone number
          <div className="flex-row no-margin nowrap form-phone-row">
            <select
              name="phoneCountry"
              onChange={inputChangeHandler}
              value={input.phoneCountry}>
              {phoneNumber.map(({ label }) => (
                <option value={label} key={label}>
                  {label}
                </option>
              ))}
            </select>
            <input
              type="number"
              id="form-phone"
              name="phoneNumber"
              value={input.phoneNumber}
              onChange={inputChangeHandler}
              placeholder={
                isMobile ? 'Enter phone no.' : 'Enter your phone number'
              }
              required
            />
          </div>
          {error.phoneNumber && <p className="red">{error.phoneNumber}</p>}
        </label>
      </div>
      <div className="flex-row">
        <div className="form-group col-6 col">
          <label htmlFor="form-company">
            Company
            <input
              id="form-company"
              type="text"
              placeholder="Where do you work at?"
              name="company"
              onChange={inputChangeHandler}
              value={input.company}
              required
            />
          </label>
          {error.company && <p className="red">{error.company}</p>}
        </div>
        <div className="form-group col-6 col">
          <label htmlFor="form-job-title">
            Job title
            <input
              type="text"
              id="form-job-title"
              placeholder="What’s your job title?"
              name="jobTitle"
              onChange={inputChangeHandler}
              value={input.jobTitle}
              required
            />
          </label>
          {error.jobTitle && <p className="red">{error.jobTitle}</p>}
        </div>
      </div>
      <div className="form-group">
        <label htmlFor="form-number-job-postings">
          No of job postings
          <select
            id="form-number-job-postings"
            name="jobPostings"
            onChange={inputChangeHandler}
            value={input.jobPostings}>
            <option value={prices.jobs[0]}>{prices.jobs[0]}</option>
            <option value={prices.jobs[1]}>{prices.jobs[1]}</option>
            <option value={prices.jobs[2]}>{prices.jobs[2]}</option>
            <option value={prices.jobs[3]}>{prices.jobs[3]}</option>
            <option value={prices.jobs[4]}>{prices.jobs[4]}+</option>
          </select>
        </label>
      </div>
      <div className="form-group">
        <button
          className="button button-green"
          type="submit"
          disabled={isSubmitting}>
          {isSubmitting ? 'Submitting...' : 'Join Waitlist'}
        </button>
      </div>
    </form>
  );
};

JoinForm.propTypes = {
  step: PropTypes.number.isRequired,
  formSubmitted: PropTypes.bool.isRequired,
  setFormSubmitted: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export default JoinForm;
